import {
    select,
    all,
    fork,
    put,
    takeEvery,
    takeLatest,
  } from "redux-saga/effects";
  import { has, isNil, includes, isEmpty } from "ramda";
  import { ResetSTAN, ResetSTANActionTypes } from "./types";
  import { save } from "../../repo/resetTerminalSTAN";
  import {
    saveRequest,
    saveSuccess,
    saveError,
  } from "./actions";
  import { dirty } from "../session/actions";
  import { Error, isAuthError } from "../";
  
  function* handleSave(action: ReturnType<typeof saveRequest>) {
    try {
      const terminal = yield save(action.payload.data);
      // we may still have an error
      // if so then we should yield error
      if (terminal.errors && !isEmpty(terminal.errors)) {
        if (isAuthError(terminal.errors)) {
          yield put(dirty());
        }
        yield put(saveError(JSON.stringify(terminal.errors)));
        action.payload.callback &&
          action.payload.callback(JSON.stringify(terminal.errors), null);
      } else {
        yield put(saveSuccess(terminal));
        action.payload.callback && action.payload.callback(null, terminal);
      }
    } catch (err) {
      yield put(saveError(err));
      action.payload.callback &&
        action.payload.callback("An error occurred while reset terminal STAN", null);
    }
  }
  
  function* watchSaveRequest() {
    yield takeEvery(ResetSTANActionTypes.SAVE_REQUEST, handleSave);
  }
  
  export default function* resetStanSaga() {
    yield all([
      fork(watchSaveRequest),
    ]);
  }
  